export default __webpack_public_path__ + "static/media/jpgIcon.beb3ddd8.svg";